<template>

</template>
<script>
import CoreEmit from '../../components/core-emit/index.vue'
import AppHeadert from '../../components/app-header/index.vue'
import AppWords from '../../components/app-words/index.vue'
import AppCounter from '../../components/app-counter/index.vue'
import AppSlicedText from '../../components/app-sliced-text/index.vue'
import AppPartnersSlideshow from '../../components/app-partners-slideshow/index.vue'

import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
export default {
  name: "app-scroll-object",
               components: {
                   CoreEmit,
                    AppHeadert,
                   AppWords,
                   AppCounter,
                   AppSlicedText,
                   AppPartnersSlideshow
               },
               props: {
                 debug: {
                     type: Boolean,
                     default: !1
                 },
                   content: {
                       type: Object,
                       default: function() {}
                   },
                   ratio: {
                       type: Number,
                       default: 1
                   },
                   scale: {
                       type: Number,
                       default: 1
                   },
                   isParallax: {
                       type: Boolean,
                       default: !1
                   },
                   isScroll: {
                       type: Boolean,
                       default: !1
                   },
                   parallaxRatio: {
                       type: Number,
                       default: .075
                   },
                   hasTilling: {
                       type: Boolean,
                       default: !0
                   },
                   nodeActiveClass: {
                       type: String,
                       default: "el"
                   },

                   offset: {
                       type: Number,
                       default: 0
                   },
                   link: {
                       type: String,
                       default: ""
                   },
                   title: {
                       type: String,
                       default: ""
                   },
                   index: {
                       type: Number,
                       default: 0
                   },
                   OffsetHeighManual: {
                       type: Number,
                       default: 0
                   },
                   activeFactIndex: {
                       type: Number,
                       default: -1
                   },
                   headerPageSize: {
                       type: Array,
                       default: function() {}
                   }
               },
               data: function() {
                   return {
                       isActive: !1
                   }
               },
               created: function() {
                   this._height = 0,
                   this._offsetY = 0,
                    this._fullOffsetY = 0,
                     this._currScrollTop = 0,
                     this._securityMerge = this.$root.isTouch ? 100 : 0,
                     this.onResize = this.onResize.bind(this),
                     this.onEnterFrame = this.onEnterFrame.bind(this),
                     this.eventHub.$on("resize", this.onResize),
                     this.eventHub.$on("enterframe", this.onEnterFrame)
               },
               mounted: function()
               {
                   this.$child = this.$el.children[0],
                    "el" === this.nodeActiveClass ? this.$node = this.$el : "parent" === this.nodeActiveClass && (this.$node = this.$el.parentElement),
                    this.onResize()
               },
               destroyed: function()
               {
                   this.eventHub.$off("resize", this.onResize),
                   this.eventHub.$off("enterframe", this.onEnterFrame)
               },
               methods:
               {
                   onResize: function()
                   {


                       this._height = this.$el.offsetHeight,
                        this._offsetY = (0,getAbsoluteBoundingRect)(this.$el).top,
                        this._fullOffsetY = this._height + this._offsetY

                   },
                   onEnterFrame: function()
                   {

                      
                   }
               }
}
</script>
<style  scoped>
</style>
